(function () {

  var STORAGE_KEY = 'se_cep_last';

  // --- Utilitários ---

  function formatCEP(value) {
    const raw = value.replace(/\D/g, '').slice(0, 8);
    return raw.length > 5 ? raw.slice(0, 5) + '-' + raw.slice(5) : raw;
  }

function formatCurrency(value) {
  const raw = parseFloat(value);
  if (isNaN(raw) || raw === 0) return 'Grátis';

  const isInCents = Number.isInteger(raw) && raw > 100;
  const reais = isInCents ? raw / 100 : raw;

  return 'R$ ' + reais.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}



  function formatDeliveryTime(rate) {
    if (Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
      const min = rate.delivery_days[0];
      const max = rate.delivery_days[rate.delivery_days.length - 1];
      return min === max ? min + ' dias úteis' : min + ' a ' + max + ' dias úteis';
    }
    if (rate.delivery_date) {
      return 'Entrega prevista: ' + new Date(rate.delivery_date + 'T12:00:00').toLocaleDateString('pt-BR');
    }
    return null;
  }

  function formatLocation(address, cepFormatted) {
    if (address && address.localidade && address.uf) {
      return address.localidade.trim() + '-' + address.uf.trim();
    }
    return cepFormatted;
  }

  function isValidBrazilianCEP(cep) {
    return /^\d{8}$/.test(cep);
  }

  // --- localStorage ---

  function saveLastCEP(cleanCEP) {
    try { localStorage.setItem(STORAGE_KEY, cleanCEP); } catch (e) {}
  }

  function loadLastCEP() {
    try { return localStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
  }

  // --- CEP ativo (prioridade: localStorage > cadastro > vazio) ---

  function getActiveCEP() {
    const stored = loadLastCEP().replace(/\D/g, '');
    if (isValidBrazilianCEP(stored)) return stored;

    const root = document.getElementById('shipping-estimator');
    if (!root) return '';
    const customerZip = (root.getAttribute('data-customer-zip') || '').replace(/\D/g, '');
    if (isValidBrazilianCEP(customerZip)) return customerZip;

    return '';
  }

  // --- Erros dentro do modal ---

  function showModalError(message) {
    const errorEl = document.getElementById('shipping-estimator-modal-error');
    const input = document.getElementById('shipping-estimator-cep');
    if (errorEl) { errorEl.textContent = message; errorEl.hidden = false; }
    if (input) input.classList.add('shipping-estimator__input--error');
  }

  function clearModalError() {
    const errorEl = document.getElementById('shipping-estimator-modal-error');
    const input = document.getElementById('shipping-estimator-cep');
    if (errorEl) { errorEl.textContent = ''; errorEl.hidden = true; }
    if (input) input.classList.remove('shipping-estimator__input--error');
  }

  // --- Render resultados ---

  function renderResults(container, rates, address, cepFormatted) {
    if (!rates || rates.length === 0) {
      container.innerHTML = '<p class="shipping-estimator__loading">Nenhuma opção de frete disponível para este CEP.</p>';
      return;
    }

    const location = formatLocation(address, cepFormatted);
    const label = document.getElementById('shipping-estimator-label');
    if (label) label.textContent = 'Frete para ' + location;

    let html = '<ul class="shipping-estimator__list">';
    rates.forEach(function (rate) {
      const prazo = formatDeliveryTime(rate);
      html += '<li class="shipping-estimator__item">';
      html += '<span class="shipping-estimator__carrier">' + rate.name + '</span>';
      html += '<span class="shipping-estimator__price">' + formatCurrency(rate.price) + '</span>';
      if (prazo) {
        html += '<span class="shipping-estimator__deadline">Prazo: ' + prazo + '</span>';
      }
      html += '</li>';
    });
    html += '</ul>';
    container.innerHTML = html;
  }

  // --- Estado do botão ---

  function setBtnLoading(loading) {
    const btn = document.getElementById('shipping-estimator-btn');
    if (!btn) return;
    btn.disabled = loading;
    btn.textContent = loading ? 'Calculando...' : 'Confirmar';
  }

  // --- Fetch principal ---

  function fetchRates(cep, resultsContainer, silent) {
    const cleanCEP = cep.replace(/\D/g, '');

    if (!isValidBrazilianCEP(cleanCEP)) {
      if (!silent) showModalError('CEP inválido. Digite os 8 números corretamente.');
      return Promise.resolve('error');
    }

    clearModalError();
    if (!silent) setBtnLoading(true);

    const ufMap = {
      'AC':'Acre','AL':'Alagoas','AP':'Amapá','AM':'Amazonas','BA':'Bahia',
      'CE':'Ceará','DF':'Distrito Federal','ES':'Espírito Santo','GO':'Goiás',
      'MA':'Maranhão','MT':'Mato Grosso','MS':'Mato Grosso do Sul','MG':'Minas Gerais',
      'PA':'Pará','PB':'Paraíba','PR':'Paraná','PE':'Pernambuco','PI':'Piauí',
      'RJ':'Rio de Janeiro','RN':'Rio Grande do Norte','RS':'Rio Grande do Sul',
      'RO':'Rondônia','RR':'Roraima','SC':'Santa Catarina','SP':'São Paulo',
      'SE':'Sergipe','TO':'Tocantins'
    };

    return fetch('https://viacep.com.br/ws/' + cleanCEP + '/json/')
      .then(function (res) { return res.json(); })
      .then(function (address) {
        if (address.erro) {
          if (!silent) {
            showModalError('CEP não encontrado. Verifique e tente novamente.');
            setBtnLoading(false);
          }
          return 'error';
        }

        const province = ufMap[address.uf] || address.uf;
        const params = new URLSearchParams({
          'shipping_address[zip]': cleanCEP,
          'shipping_address[country]': 'BR',
          'shipping_address[province]': province
        });

        return fetch('/cart/shipping_rates.json?' + params.toString())
          .then(function (res) {
            if (!res.ok) throw new Error('Erro ' + res.status);
            return res.json();
          })
          .then(function (data) {
            if (!silent) setBtnLoading(false);
            renderResults(resultsContainer, data.shipping_rates, address, formatCEP(cleanCEP));
            saveLastCEP(cleanCEP);
            return 'ok';
          });
      })
      .catch(function (err) {
        console.error('Shipping estimator error:', err);
        if (!silent) {
          showModalError('Erro ao calcular frete. Verifique sua conexão e tente novamente.');
          setBtnLoading(false);
        }
        return 'error';
      });
  }

  // --- Modal: abrir / fechar ---

  function openModal() {
    const overlay = document.getElementById('shipping-estimator-overlay');
    const trigger = document.getElementById('shipping-estimator-trigger');
    if (!overlay) return;
    clearModalError();
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    const input = document.getElementById('shipping-estimator-cep');
    if (input) {
      const active = getActiveCEP();
      if (active) input.value = formatCEP(active);
      setTimeout(function () { input.focus(); }, 50);
    }
  }

  function closeModal() {
    const overlay = document.getElementById('shipping-estimator-overlay');
    const trigger = document.getElementById('shipping-estimator-trigger');
    if (!overlay) return;
    overlay.hidden = true;
    document.body.style.overflow = '';
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function confirmCEP() {
    const input = document.getElementById('shipping-estimator-cep');
    const results = document.getElementById('shipping-estimator-results');
    if (!input || !results) return;
    fetchRates(input.value, results, false).then(function (status) {
      if (status === 'ok') closeModal();
    });
  }

  // --- Auto-cálculo ---

  function autoCalculate() {
    const activeCEP = getActiveCEP();
    if (!activeCEP) return;

    const results = document.getElementById('shipping-estimator-results');
    const input = document.getElementById('shipping-estimator-cep');
    if (!results) return;

    if (input) input.value = formatCEP(activeCEP);
    fetchRates(activeCEP, results, true);
  }

  // --- MutationObserver: observa mudanças no carrinho ---
  // Detecta quando o Trade re-renderiza os itens (quantidade, remoção, adição)
  // e recalcula o frete automaticamente com o último CEP

  var calcDebounceTimer = null;

  function startCartObserver() {
    // O Trade re-renderiza o elemento cart-items ou a tabela de itens
    // Observamos o ancestral mais próximo estável do carrinho
    var cartTarget =
      document.querySelector('cart-items') ||
      document.querySelector('.cart__items') ||
      document.querySelector('form[action="/cart"]');

    if (!cartTarget) return;

    var observer = new MutationObserver(function (mutations) {
      // Ignora mutações causadas pelo próprio shipping-estimator
      var relevant = mutations.some(function (m) {
        return !document.getElementById('shipping-estimator').contains(m.target);
      });
      if (!relevant) return;

      // Debounce: aguarda o Trade terminar de re-renderizar antes de recalcular
      clearTimeout(calcDebounceTimer);
      calcDebounceTimer = setTimeout(function () {
        autoCalculate();
      }, 600);
    });

    observer.observe(cartTarget, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // --- Event delegation ---

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest('#shipping-estimator-trigger')) {
      openModal(); return;
    }
    if (e.target && e.target.closest('#shipping-estimator-close')) {
      closeModal(); return;
    }
    if (e.target && e.target.id === 'shipping-estimator-overlay') {
      closeModal(); return;
    }
    if (e.target && e.target.id === 'shipping-estimator-btn') {
      confirmCEP(); return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key === 'Enter' && e.target && e.target.id === 'shipping-estimator-cep') {
      confirmCEP();
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'shipping-estimator-cep') {
      e.target.value = formatCEP(e.target.value);
      const len = e.target.value.length;
      e.target.setSelectionRange(len, len);
      clearModalError();
    }
  });

  // Mantém compatibilidade com temas que disparam cart:updated
  document.addEventListener('cart:updated', autoCalculate);

  // --- Init ---

  function init() {
    autoCalculate();
    startCartObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
